// modules分成不同功能的模块
import * as types from './../mutation-types.js';
import Vue from 'vue'
var target = this
const state = {
  filterList: []
}



const getters = {
  filterList: state => state.filterList
}

const mutations = {
  [types.GET_FILTERLIST](state, res) {
    var fliterObj = {}
    for (var key in res) {
      fliterObj[key] = []
      for (var sonKey in res[key]){
        var obj = {
          text: res[key][sonKey],
          value: sonKey
        }
        fliterObj[key].push(obj)
      }
    }
    state.filterList = fliterObj
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/filter.js